import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/blog/BlogCard.css";
import navIMG from "../../assets/app/Nav/LOGO-FONDO-NEGRO.png";
import { useTranslation } from "react-i18next";

interface BlogCardProps {
  imageName: string;
  date: string;
  title: string;
  description: string;
}

const BlogCard: React.FC<BlogCardProps> = ({
  imageName,
  date,
  title,
  description,
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleReadMore = () => {
    const slug = title.replace(/\s+/g, "-").toLowerCase();
    navigate(slug, { state: { imageName, date, title, description } });
  };

  const URL_BACK_IMG = process.env.REACT_APP_API_IMGBLOG_URL;

  return (
    <div className="blog-card" onClick={handleReadMore}>
      <div className="blog-card-visuals">
        <div className="blog-card-image-container">
          <img
            src={`${URL_BACK_IMG}${imageName}`}
            alt={title}
            className="blog-card-image"
            loading="lazy"
          />
        </div>
        <p className="blog-card-date">
          {new Date(date).toLocaleDateString(i18n.language, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      </div>
      <div className="blog-card-content">
        <h3 className="blog-card-title">{title}</h3>
        <p className="blog-card-description">{description}</p>
        <button className="blog-card-read-more" onClick={handleReadMore}>
          {t("blog.readMore")}
        </button>
      </div>
    </div>
  );
};

export default BlogCard;
